import { SUMMARY_REPORT_OBJECT_TYPE } from "./summaryReportObjectType";
export default {
    [SUMMARY_REPORT_OBJECT_TYPE.GRAPH_SCREEN]: "icon-border-corners",
    [SUMMARY_REPORT_OBJECT_TYPE.DOCUMENT_OBJECT_NODES]: "icon-card",
    [SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS]: "icon-table",
    [SUMMARY_REPORT_OBJECT_TYPE.MAP_SCREEN]: "icon-map",
    [SUMMARY_REPORT_OBJECT_TYPE.CONTENT]: "icon-gallery"
};
